module.exports = require('./cjs');


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-forward/index.js
// module id = 454
// module chunks = 6